<template>
  <sa-page-layout :viewFilterSection="false" :btnBackVisible="false" :linkback="linkback" :linkedit="linkedit" :pathResource="pathResource" :showModalLoading="showModalLoading">

        <template slot="table-body">
            <!-- <planning-component></planning-component> -->
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
// import PlanningComponent from '../../../utility/components/PlanningComponent.vue';
    export default {
        // PlanningComponent,
        components:{SaPageLayout},
        data(){
       return {
            filtro: {},
            pathResource: null,
            pathResourceAccettazione: "/accettazioni",
            linkedit: null,
            linkback: "/rsagestioneospiti", 
            pathResouceUserProfile:"/users/profile",
            pathResourceUtentiPresidi:"/utentipresidi",
            showModalLoading: false,
            listKey: 0,
            jsonData: { accettazioneAnagrafica: {}, accettazionePrestazioni: {}, accettazioneStati: [], accettazioneStruttura: {}, accettazionePresidio: {} },
        };
        },
        mounted() {
        let me = this;
        me.idAccettazione = this.$route.query.idAccettazione;
        me.loadAccettazione();
    },
    methods: {
        loadAccettazione() {
            let me = this;
            me.showModalLoading = false;
           // let link = process.env.VUE_APP_PATH_API + me.pathResourceAccettazione + "/" + me.idAccettazione;
           
        },
    },
    }
</script>

<style lang="scss" scoped>

</style>